import { IonContent, isPlatform } from '@ionic/react';
import React, { useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormInput } from '@/components/FormInput';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { MAX_USERNAME_LENGTH } from '@/pages/Onboarding/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { useNameAnumation } from '@/pages/Onboarding/Layouts/screens/Name/hooks/useNameAnumation';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LureScreenFooter } from '../../components/LureScreenFooter';
import { LayoutDataType } from '../../types';

import { ScreenNameStyles } from './Name.styles';

export const ScreenName: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Name',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { refreshUser } = useAccount();
  const form = useFormContext<LayoutDataType>();
  const { nameResponseRef, play, responseRef, titleRef } = useNameAnumation();

  const [showInput, setShowinput] = useState<boolean>(true);
  const [userName, setUserName] = useState<string>('');

  const inputRef = useRef<HTMLIonInputElement | null>(null);

  const formName = form.watch('name');
  const disableNextStep = !formName;

  const submit = (): void => {
    if (formName) {
      setShowinput(false);
      setUserName(formName);
      play();
    }
  };

  React.useEffect(() => {
    setUserName('');

    if (isPlatform('android') || isPlatform('desktop')) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.getInputElement().then((inputEl) => {
            inputEl.focus();
          });
        }
      });

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.getInputElement().then((inputEl) => {
            inputEl.focus();
          });
        }
      }, 1000);
    }
  }, []);

  const handleNextStep = (): void => {
    userService
      .createOrUpdate({
        name: formName,
      })
      .then(() => {
        refreshUser();
      });

    wizard.nextStep();
  };

  const handleBackStep = (): void => {
    wizard.goToStep('security');
  };

  return (
    <ScreenNameStyles>
      <OnboardingNavigation onBack={handleBackStep} />

      <div className="response">
        <OwnAiTitle ref={titleRef}>
          What would you like AI characters to call you?
        </OwnAiTitle>
        <OwnAiTitle ref={nameResponseRef}>{userName}</OwnAiTitle>
        <OwnAiTitle ref={responseRef} className="response-start">
          Nice to meet you, {formName}!
        </OwnAiTitle>
      </div>

      <IonContent>
        <FormInput
          form={form}
          hidden={!showInput}
          disableButton={disableNextStep}
          onSubmit={submit}
          ref={inputRef}
          name="name"
          placeholder="Type your name"
          type="text"
          maxLength={MAX_USERNAME_LENGTH}
        />
      </IonContent>

      <LureScreenFooter
        disabled={disableNextStep}
        onContinue={handleNextStep}
        hidden={showInput}
      />
    </ScreenNameStyles>
  );
};
